import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="footer-brand-name">Million Minds</div>
            <p className="footer-brand-desc">
              AI-powered college placement and internship platform. Bridging the gap between ambitious students, top-tier colleges, and industry-leading companies.
            </p>
            <div className="footer-social">
              <a href="#" className="footer-social-btn">in</a>
              <a href="#" className="footer-social-btn">tw</a>
              <a href="#" className="footer-social-btn">ig</a>
            </div>
          </div>
          
          <div>
            <h4 className="footer-heading">For Students</h4>
            <div className="footer-links">
              <Link to="/browse" className="footer-link">Browse Jobs</Link>
              <Link to="/register" className="footer-link">Register Profile</Link>
              <Link to="/login" className="footer-link">Student Login</Link>
              <Link to="#" className="footer-link">Resume Builder</Link>
            </div>
          </div>
          
          <div>
            <h4 className="footer-heading">For Employers</h4>
            <div className="footer-links">
              <Link to="/company/register" className="footer-link">Post a Job</Link>
              <Link to="/company/login" className="footer-link">Company Login</Link>
              <Link to="#" className="footer-link">Search Resumes</Link>
              <Link to="#" className="footer-link">Pricing Plans</Link>
            </div>
          </div>
          
          <div>
            <h4 className="footer-heading">Platform</h4>
            <div className="footer-links">
              <Link to="/college/partner" className="footer-link">College Partnerships</Link>
              <Link to="/admin/login" className="footer-link">Admin Portal</Link>
              <Link to="#" className="footer-link">About Us</Link>
              <Link to="#" className="footer-link">Contact Support</Link>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Million Minds. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="#" className="footer-link">Privacy Policy</Link>
            <Link to="#" className="footer-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
